import React from 'react';
import { observer } from 'mobx-react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';

const mode = import.meta.env.VITE_DO_MODE;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  appBar: {
    backgroundColor: mode === 'vision' ? theme.palette.primary[700] : 'black',
  },
  logo: {
    maxHeight: '50px',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  button: {},
}));

type PublicLayoutProps = {
  children: React.ReactNode;
};

export const PublicLayout: React.FC = observer((props: PublicLayoutProps) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const mode = import.meta.env.VITE_DO_MODE || 'matrix';

  return (
    <>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          {mode === 'vision' ? (
            <img src="/visionLogo.svg" alt="Vision Fitness"></img>
          ) : (
            <img
              className={classes.logo}
              src={'https://images.jhtassets.com/6747ec2d9c74a0ac9b16e33e5a97e571aecac1fc/'}
              alt="Matrix"
            ></img>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar />
      {props.children}
    </>
  );
});

export default PublicLayout;
